// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map,
.map img,
.map #mapoo {
  width: 100%;
  height: 250px;
}
@media screen and (max-width: 768px) {
  .map,
  .map img,
  .map #mapoo {
    height: 50vh;
  }
}

#mapoo {
  width: 100%;
  height: 100%;
}

#page-programme #mapoo {
  width: 100%;
  height: 250px;
}
@media screen and (max-width: 768px) {
  #page-programme #mapoo {
    height: 50vh;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
